import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { askQuestionRequested } from 'features/qa/actions';

export function* askQuestionSaga(action: ReturnType<typeof askQuestionRequested>) {
  const { question, anonymous } = action.payload;

  yield call(SignalingSocket.send, {
    event: 'askQuestion',
    data: {
      question,
      anonymous,
    },
  });
}
